export default "__VITE_ASSET__v07hYQp2__";